export default class NormalizedError extends Error {
    constructor(message, originalError = null) {
        super(message || "Erro inesperado. Tente novamente.");
        this.originalError = originalError;
        this.name = "NormalizedError";
    }
}